import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { backend_url } from '../App'; 
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../Pages/CSS/AdminUpdatePassword.css';

const AdminUpdatePassword = () => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();

    const handleUpdatePassword = async (e) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            toast.error('New password and confirm password do not match!', { position: "top-center" });
            return;
        }

        try {
            const token = sessionStorage.getItem('adminToken');
            const response = await axios.put(
              `${backend_url}/api/admin/update-password`, 
              { oldPassword, newPassword },
              { headers: { Authorization: `Bearer ${token}` } }
            );
            toast.success(response.data.message, { position: "top-center" });
            setOldPassword('');
            setNewPassword('');
            setConfirmPassword('');
            navigate("/admin/login"); 
        } catch (err) {
            toast.error(err.response?.data?.message || 'Something went wrong', { position: "top-center" });
        }
    };

    return (
        <>
        <div className="admin-password-container">
            <h2>Update Password</h2>
            <form onSubmit={handleUpdatePassword} className="password-form">
                <div className="input-group">
                    <input
                        type={showOldPassword ? 'text' : 'password'}
                        placeholder="Old Password"
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                        required
                    />
                    <span onClick={() => setShowOldPassword(!showOldPassword)}>
                        {showOldPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                </div>

                <div className="input-group">
                    <input
                        type={showNewPassword ? 'text' : 'password'}
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                    />
                    <span onClick={() => setShowNewPassword(!showNewPassword)}>
                        {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                </div>

                <div className="input-group">
                    <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                    <span onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                </div>

                <button type="submit" className="update-button">Update Password</button>
            </form>
        </div>
<ToastContainer/>
        </>
    );
};

export default AdminUpdatePassword;
